import Proxy from '../Proxy';

class ReportProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('report', parameters);
  }

  ordersBaseListingReport() {
    return this.submit('get', `/${this.endpoint}/orders-base/listing`);
  }

  ordersBaseListingEmailReport() {
    return this.submit('get', `/${this.endpoint}/send-email/orders-base/listing`);
  }

  ordersBaseHooverListingReport() {
    return this.submit('get', `/${this.endpoint}/orders-base-hoover/listing`);
  }

  ordersCreatedListingReport() {
    return this.submit('get', `/${this.endpoint}/orders-created/listing`);
  }

  ordersComplexListingReport() {
    return this.submit('get', `/${this.endpoint}/orders-complex/listing`);
  }

  ordersComplexListingEmailReport() {
    return this.submit('get', `/${this.endpoint}/send-email/orders-complex/listing`);
  }

  contactsListingReport() {
    return this.submit('get', `/${this.endpoint}/contacts/listing`);
  }

  contactsListingEmailReport() {
    return this.submit('get', `/${this.endpoint}/send-email/contacts/listing`);
  }

  contactsLTVMetricsReport() {
    return this.submit('get', `/${this.endpoint}/contacts/ltv-metrics`);
  }

  cleanersListingReport() {
    return this.submit('get', `/${this.endpoint}/cleaners/listing`);
  }

  salaryCleanerBaseListingReport() {
    return this.submit('get', `/${this.endpoint}/salary/cleaners-base/listing`);
  }

  estimationsComplexListingReport() {
    return this.submit('get', `/${this.endpoint}/estimations-complex/listing`);
  }

  phonesListingReport() {
    return this.submit('get', `/${this.endpoint}/form-phones/listing`);
  }

  expenseListingReport() {
    return this.submit('get', `/${this.endpoint}/expenses/listing`);
  }

  incomeListingReport() {
    return this.submit('get', `/${this.endpoint}/incomes/listing`);
  }

  discountsListingReport() {
    return this.submit('get', `/${this.endpoint}/discounts/listing`);
  }

  negativesListingReport() {
    return this.submit('get', `/${this.endpoint}/negatives/listing`);
  }

  damagesListingReport() {
    return this.submit('get', `/${this.endpoint}/damages/listing`);
  }

  revenueStatsListingEmailReport() {
    return this.submit('get', `/${this.endpoint}/send-email/revenue-stats/listing`);
  }
}

export default ReportProxy;
